export { getStepHeading, ORDERED_TYPOGRAPHY_VARIANTS } from './getStepHeading'
